<template>
  <section class="admin-content " id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-info m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">

            <div class="col-md-6 text-center mx-auto text-white p-b-30">

              <h3 class="h3">SMS Notifications</h3>

              <download-excel :data="recipients" :fields="json_fields" class="btn btn-success" :escapeCsv=false
                name="recipients.xls">
                <span class="fe fe-download"></span>
                Export Contact Data
              </download-excel>

            </div>

          </div>
        </div>
      </div>
      <section class="">
        <div class="container">

          <div class="row list">
            <div class="col-lg-8 offset-md-2">
              <div class="card m-b-30">

                <div class="card-body">
                  <div class="form-row">

                    <div class="form-group col-md-12">
                      <label for="inputPassword4">Select Recipient Category </label>
                      <select class="form-control" v-model="sms_type">
                        <option value="single">Type</option>
                        <option value="bulk">Select</option>

                      </select>
                    </div>
                    <div class="form-group col-md-12" v-if="sms_type == 'bulk'">
                      <label for="inputPassword4">Select Program </label>
                      <v-select v-model="category" :options="sectors" :reduce="name => name.name" multiple
                        label="name"></v-select>
                    </div>
                    <div class="form-group col-md-6" v-if="sms_type == 'bulk'">
                      <label for="inputCity"><i class="fe fe-calendar"></i> Start Date </label>
                      <input type="date" class="form-control" v-model="from" @change="pushDate" />
                    </div>

                    <div class="form-group col-md-6" v-if="sms_type == 'bulk'">
                      <label for="inputCity"><i class="fe fe-calendar"></i> End Date </label>
                      <input type="date" class="form-control" v-model="to" @change="pushDate" />
                    </div>

                    <div class="form-group col-md-12" v-if="sms_type == 'bulk'">
                      <label for="inputAddress">Bulk Recipients: <span class="text-primary">{{bulkRecipientsCount}}
                          recipients</span></label>
                      <div class="mb-2">
                        <button class="btn btn-outline-info btn-sm" type="button" @click="$refs.bulkCsvInput.click()">
                          Upload CSV List
                        </button>
                        <input ref="bulkCsvInput" type="file" class="d-none" accept=".csv,text/csv"
                          @change="handleSmsCsvUpload($event, 'bulk')" />
                      </div>
                      <textarea name="name" rows="8" class="form-control" placeholder="Phone Numbers"
                        v-model="bulkRecipients" readonly></textarea>
                    </div>
                    <div class="form-group col-md-12" v-if="sms_type == 'single'">
                      <label for="inputAddress">Manual Input Recipients: </label>
                      <div class="mb-2">
                        <button class="btn btn-outline-info btn-sm" type="button" @click="$refs.singleCsvInput.click()">
                          Upload CSV List
                        </button>
                        <p class="text-info small font-italic">phone_number field must be present</p>

                        <input ref="singleCsvInput" type="file" class="d-none" accept=".csv,text/csv"
                          @change="handleSmsCsvUpload($event, 'single')" />
                      </div>
                      <textarea name="name" rows="5" class="form-control" placeholder="Phone Number"
                        v-model="singlerecipient"></textarea>
                      <p>
                        <span class="text-primary">{{singleRecipientsCount}} recipients</span>
                      </p>
                    </div>
                    <div class="form-group col-md-12">
                      <label for="inputAddress">Message</label>
                      <textarea name="name" rows="8" class="form-control" placeholder="Message Body here"
                        v-model="message"></textarea>
                      <p>
                        <span class="text-primary">{{message.length}} characters/160 per page</span>
                      </p>
                    </div>

                  </div>


                  <div class="form-group">
                    <button class="btn btn-info btn-block btn-lg" @click="sendSMS">Send Message</button>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>


      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin

  import sectorsJson from "@/json/sectors_dynamic.json";
  import vulnerablesJson from "@/json/vulnerables.json";

  export default {
    components: {
      Navbar, Loading
    },
    data() {
      return {
        editor: ClassicEditor,
        user: null,
        category: "",
        sms_type: "single",
        message: "",
        recipients: "",
        bulkRecipients: "",
        singlerecipient: "",
        postId: "",
        edit: false,
        isLoading: false,
        fullPage: true,
        date: "",
        from: "",
        to: "",
        json_fields: {
          'PhoneNumber': 'phone_number',
          'FIRST NAME': 'firstname',
          'MESSAGES': {
            field: 'userprovider.agency_name',
            callback: (value) => {
              return `  ${value}`;
            }
          },

        },
        json_data: [],
        json_meta: [
          [
            {
              key: "charset",
              value: "utf-8",
            },
          ]],


      }
    },
     mounted() {
      //get Agency By ID
      let sectors = sectorsJson;
      let formatter = sectors.filter(
        (x) => x.agency_id == this.agency.id
      );
      this.sectors = formatter;
      console.log(JSON.stringify(this.sectors) + "sectors");

      //get Vulnerables By ID
      let vulnerables = vulnerablesJson;
      let formatterVulnerables = vulnerables.filter(
        (x) => x.agency_id == this.agency.id
      );
      this.vulnerables = formatterVulnerables;


    },

    beforeMount() {
      this.user = JSON.parse(localStorage.getItem('user'))

    },

    computed: {
      bulkRecipientsCount() {
        if (!this.bulkRecipients) return 0
        return this.bulkRecipients
          .split(',')
          .map(value => value.trim())
          .filter(Boolean)
          .length
      },
      singleRecipientsCount() {
        if (!this.singlerecipient) return 0
        return this.singlerecipient
          .split(',')
          .map(value => value.trim())
          .filter(Boolean)
          .length
      }
    },

    methods: {
      pushDate() {
        this.date = 'date'
      },
      handleSmsCsvUpload(event, target) {
        const file = event.target.files && event.target.files[0]
        if (!file) return

        const reader = new FileReader()
        reader.onload = (e) => {
          const content = e.target.result || ""
          const recipients = this.parseCsvRecipients(content)
          const recipientString = recipients.join(',')

          if (target === 'bulk') {
            this.bulkRecipients = recipientString
          } else {
            this.singlerecipient = recipientString
          }

          this.$toasted.info(`Loaded ${recipients.length} recipients from CSV`, {
            position: 'top-center',
            duration: 3000
          })

          event.target.value = ''
        }

        reader.onerror = () => {
          this.$toasted.error('Could not read CSV file', { position: 'top-center', duration: 3000 })
          event.target.value = ''
        }

        reader.readAsText(file)
      },
      parseCsvRecipients(content) {
        const tokens = content
          .split(/[\n,;\t\r]+/)
          .map(value => value.replace(/^"|"$/g, '').trim())
          .filter(Boolean)

        const unique = new Set()
        tokens.forEach((value) => {
          const normalized = value.replace(/\s+/g, '')
          if (/^\+?\d{8,15}$/.test(normalized)) {
            unique.add(normalized)
          }
        })

        return Array.from(unique)
      },
      clearIt() {
        this.recipients = ""
        this.bulkRecipients = ""
        this.messages = ""
        this.category = ""

      },

      getRecipients() {
        this.isLoading = true
        this.axios.get(`/api/v1/auth/sms/filter/${this.category}/4`, {
          params: {
            date: this.date,
            from: this.from,
            to: this.to
          }
        })
          .then(response => {
            this.recipients = response.data
            if (Array.isArray(response.data)) {
              this.bulkRecipients = response.data
                .map(item => item.phone_number)
                .filter(Boolean)
                .join(',')
            } else {
              this.bulkRecipients = response.data || ""
            }
            console.log(response)
            this.isLoading = false
            this.$toasted.info('Recipients Synced Successfully', { position: 'top-center', duration: 3000 })

          })
          .catch(error => {
            console.error(error);
            this.isLoading = false
            this.$toasted.error('Error Syncing', { position: 'top-center', duration: 3000 })


          })
      },




      sendSMS() {

        if (this.sms_type == 'bulk') {
          this.isLoading = true;
          this.axios.post(`https://api.bulksmslive.com/v2/app/sms?email=faisalnas7@gmail.com&password=Whetstone@6969&sender_name=FHIS&message=${this.message}&recipients=${this.bulkRecipients}`, {

          })
            .then(response => {
              console.log(response);
              let reply = response.data.msg
              this.clearIt();
              this.isLoading = false;
              this.$toasted.info(`${reply}`, { position: 'top-center', duration: 3000 })

            })
            .catch(error => {
              console.log(error.response)
            })
        }
        else {
          this.isLoading = true;
          this.axios.post(`https://api.bulksmslive.com/v2/app/sms?email=faisalnas7@gmail.com&password=Whetstone@6969&sender_name=FHIS&message=${this.message}&recipients=${this.singlerecipient}`, {

          })
            .then(response => {
              console.log(response);
              let reply = response.data.msg
              this.clearIt();
              this.isLoading = false;
              this.$toasted.info(`${reply}`, { position: 'top-center', duration: 3000 })

            })
            .catch(error => {
              console.log(error.response)
            })
        }


      }

    },
    created() {
    }

  }
</script>